<template>
	<pui-datatable v-if="!masterDetail" :modelName="model" :actions="actions" showFilterListBtn></pui-datatable>
	<pui-datatable
		v-else
		:modelName="model"
		:actions="actions"
		:externalFilter="externalFilter"
		:masterDetail="masterDetail"
		:parentModelName="parentModelName"
		:showCreateBtn="false"
		:showDeleteBtn="false"
		:isEditableRegistry="isEditableRegistry"
	></pui-datatable>
</template>

<script>
import PuiGridDetailMixin from 'pui9-mixins/PuiGridDetailMixin';
import HistoricoLibTransTermcActions from './HistoricoLibTransTermcActions';

export default {
	name: 'historicolibtranstermcgrid',
	mixins: [PuiGridDetailMixin],
	data() {
		return {
			model: 'historicolibtranstermc',
			actions: HistoricoLibTransTermcActions.gridactions
		};
	},
	created() {
		if (this.masterDetail) {
			const parentModel = this.$store.getters.getModelByName(this.parentModelName);
			const thisModel = this.$store.getters.getModelByName(this.model);
			if (parentModel && thisModel) {
				const parentModelPk = this.$puiUtils.getPathModelMethodPk(this.$router, this.parentModelName);
				thisModel.parentModelName = this.parentModelName;
				thisModel.parentModelPk = parentModelPk.pk;
			}
		}
	},
	methods: {
		isEditableRegistry() {
			return false;
		}
	}
};
</script>

<i18n>
{
    "en": {
		"grid.historicolibtranstermc.idhistorico":"Code",
		"grid.historicolibtranstermc.idlibramiento":"Order code",
		"grid.historicolibtranstermc.usralta":"Performer code",
		"grid.historicolibtranstermc.actor":"Performer",
		"grid.historicolibtranstermc.idestadoanterior":"Previous state code",
		"grid.historicolibtranstermc.estadoanterior":"Previous state",
		"grid.historicolibtranstermc.idestadonuevo":"New state code",
		"grid.historicolibtranstermc.estadonuevo":"New state",
		"grid.historicolibtranstermc.lang":"Language",
		"grid.historicolibtranstermc.idaccion":"Action code",
		"grid.historicolibtranstermc.accion":"Action",
		"grid.historicolibtranstermc.idpuntocargaanterior":"Id. Previous loading point",
		"grid.historicolibtranstermc.puntocargaanterior":"Previous loading point",
		"grid.historicolibtranstermc.idpuntocarganuevo":"Id. New loading point",
		"grid.historicolibtranstermc.puntocarganuevo":"New loading point",
		"grid.historicolibtranstermc.fecha":"Date",
		"grid.historicolibtranstermc.fechacreacion":"Creation date"
    },
    "es": {
		"grid.historicolibtranstermc.idhistorico":"Código",
		"grid.historicolibtranstermc.idlibramiento":"Código encargo",
		"grid.historicolibtranstermc.usralta":"Código actor",
		"grid.historicolibtranstermc.actor":"Actor",
		"grid.historicolibtranstermc.idestadoanterior":"Código estado anterior",
		"grid.historicolibtranstermc.estadoanterior":"Estado anterior",
		"grid.historicolibtranstermc.idestadonuevo":"Código estado nuevo",
		"grid.historicolibtranstermc.estadonuevo":"Estado nuevo",
		"grid.historicolibtranstermc.lang":"Idioma",
		"grid.historicolibtranstermc.idaccion":"Código acción",
		"grid.historicolibtranstermc.accion":"Acción",
		"grid.historicolibtranstermc.idpuntocargaanterior":"Id. Punto de carga anterior",
		"grid.historicolibtranstermc.puntocargaanterior":"Punto de carga anterior",
		"grid.historicolibtranstermc.idpuntocarganuevo":"Id. Punto de carga nuevo",
		"grid.historicolibtranstermc.puntocarganuevo":"Punto de carga nuevo",
		"grid.historicolibtranstermc.fecha":"Fecha",
		"grid.historicolibtranstermc.fechacreacion":"Fecha creación"
	},
    "ca": {
		"grid.historicolibtranstermc.idhistorico":"Codi",
		"grid.historicolibtranstermc.idlibramiento":"Codi encàrrec",
		"grid.historicolibtranstermc.usralta":"Codi actor",
		"grid.historicolibtranstermc.actor":"Actor",
		"grid.historicolibtranstermc.idestadoanterior":"Codi estat anterior",
		"grid.historicolibtranstermc.estadoanterior":"Estat anterior",
		"grid.historicolibtranstermc.idestadonuevo":"Codi estat nou",
		"grid.historicolibtranstermc.estadonuevo":"Estat nou",
		"grid.historicolibtranstermc.lang":"Idioma",
		"grid.historicolibtranstermc.idaccion":"Codi acció",
		"grid.historicolibtranstermc.accion":"Acció",
		"grid.historicolibtranstermc.idpuntocargaanterior":"Id. Punt de càrrega anterior",
		"grid.historicolibtranstermc.puntocargaanterior":"Punt de càrrega anterior",
		"grid.historicolibtranstermc.idpuntocarganuevo":"Id. Punt de càrrega nou",
		"grid.historicolibtranstermc.puntocarganuevo":"Punt de càrrega nou",
		"grid.historicolibtranstermc.fecha":"Data",
		"grid.historicolibtranstermc.fechacreacion":"Data creació"
	}
}
</i18n>
